/* eslint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetOffersFromHistoryRequest,
  TGetOffersFromHistoryModel,
  IMappers,
  TGetOffersFromHistoryResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetOffersFromHistoryResponseSchema } from '../../entities/recommended_offers/GetOffersFromHistoryResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetOffersFromHistoryModel(parameters: IGetOffersFromHistoryRequest): TGetOffersFromHistoryModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'search-engine',
    pathApi: '/v1/get-offers-from-history/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetOffersFromHistoryOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetOffersFromHistoryRequest;
}

export async function fetchGetOffersFromHistory<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetOffersFromHistoryOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetOffersFromHistoryResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetOffersFromHistoryModel(parameters),
    config,
  )) as FetchResponse<TGetOffersFromHistoryResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetOffersFromHistoryResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetOffersFromHistoryResponse>;
}
